// True inside the admin SEO live-check frame; analytics stay off there.
export const isSeoCheckFrame = () => {
  try {
    return (
      typeof window !== "undefined" &&
      window.self !== window.top &&
      new URLSearchParams(window.location.search).has("seo_check")
    );
  } catch {
    return false;
  }
};
